import { ModelBase } from 'store/model-base';

export class EligibilityByod extends ModelBase {
    public static storeName: string = 'eligibilityByod';

    public requestId: string;
}